import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';
//
import { fNumber } from '../../utils/formatNumber';
import toEnglishNumber from '../../utils/toEnglishNumber';
// ----------------------------------------------------------------------

RHFTextFieldPrice.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFTextFieldPrice({ name, helperText, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          value={
            typeof field.value === 'number' && field.value === 0
              ? 0
              : fNumber(toEnglishNumber(field.value))
          }
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
}
